import { c as _c } from "react/compiler-runtime";
import { SourceShareEnum, sourceShareLocoKeys } from 'modules/affiliate-dashboard/enums/source-share-enum';
import React, { type JSX } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AffiliateDashboardLeadOptionSourceProps {
  sourceUrl: null | string;
  sourceText: null | SourceShareEnum;
}
export const AffiliateDashboardLeadOptionSource = t0 => {
  const $ = _c(12);
  const {
    sourceUrl,
    sourceText
  } = t0;
  const {
    t
  } = useLocoTranslation();
  if (sourceUrl) {
    let t1;
    if ($[0] !== sourceText || $[1] !== sourceUrl || $[2] !== t) {
      t1 = sourceText ? t(sourceShareLocoKeys[sourceText]) : sourceUrl;
      $[0] = sourceText;
      $[1] = sourceUrl;
      $[2] = t;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    let t2;
    if ($[4] !== sourceUrl || $[5] !== t1) {
      t2 = <LinkWithoutPrefetch className="primary-link truncate text-start" href={sourceUrl}>{t1}</LinkWithoutPrefetch>;
      $[4] = sourceUrl;
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  if (sourceText) {
    const t1 = sourceShareLocoKeys[sourceText];
    let t2;
    if ($[7] !== t || $[8] !== t1) {
      t2 = t(t1);
      $[7] = t;
      $[8] = t1;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    let t3;
    if ($[10] !== t2) {
      t3 = <span className="truncate text-start">{t2}</span>;
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  } else {
    return null;
  }
};